import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import { format, parseISO } from "date-fns";
import React, {
    useEffect,
    useState,
    useImperativeHandle,
    forwardRef,
} from "react";
import Button from "react-bootstrap/Button";
import {
    ASSET_DESC_URL,
    ASSET_DESC_BY_AI_URL,
} from "./../../Constants/Constants";
import AxiosInstance from "./../../services/AxiosInstance";
import { useAlert } from "./../alerts/AlertContext";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

function AssetDescription({ editAssetId, selectedAssetName }, ref) {
    const globaltheme = useTheme();
    const theme = createTheme({
        ...globaltheme,
        components: {
            MuiSelect: {
                defaultProps: {
                    sx: {
                        paddingLeft: "20px",
                    },
                },
            },
            MuiButton: {
                defaultProps: {
                    sx: {
                        marginTop: 2,
                        marginBottom: 2,
                        display: "block",
                    },
                },
            },
        },
    });

    const [id, setId] = useState("");
    const [assetItem, setAssetItem] = useState([]);
    const [makeModel, setMakeModel] = useState("");
    const [model, setModel] = useState("");
    const [serial, setSerial] = useState("");
    const [procurement, setProcurement] = useState("");
    const [purchaseOrder, setPurchaseOrder] = useState("");
    const [warrantyExpiry, setWarrantyExpiry] = useState("");
    const [expectedEol, setExpectedEol] = useState("");
    const [description, setDescription] = useState("");

    const showAlert = useAlert();

    const [assetDescription, setAssetDescription] = useState({
        id: "",
        makeModel: "",
        model: "",
        serial: "",
        procurement: "",
        purchaseOrder: "",
        warrantyExpiry: "",
        expectedEol: "",
        description: "",
        assetItem: { id: "" },
    });

    useEffect(() => {
        getAssetDesc();
    }, []);

    const handleMakeModelChange = (event) => {
        setMakeModel(event.target.value);
    };

    const handleModelChange = (event) => {
        setModel(event.target.value);
    };

    const handleSerialChange = (event) => {
        setSerial(event.target.value);
    };

    const handleProcurementDateChange = (date) => {
        // const isoDate = date ? format(date, "yyyy-MM-dd") : null;
        // console.log("Selected Date:", date);
        setProcurement(date);
    };

    const handlePurchaseOrderChange = (event) => {
        setPurchaseOrder(event.target.value);
    };

    const handleWarrantyExpDateChange = (date) => {
        // const isoDate = date ? format(date, "yyyy-MM-dd") : null;
        // console.log("Selected Date:", date);
        setWarrantyExpiry(date);
    };

    const handleExpectedEolChange = (date) => {
        // const isoDate = date ? format(date, "yyyy-MM-dd") : null;
        // console.log("Selected Date:", date);
        setExpectedEol(date);
    };

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (id !== "") assetDescription.id = id;

        assetDescription.makeModel = makeModel;
        assetDescription.model = model;
        assetDescription.serial = serial;
        assetDescription.procurement = procurement;
        assetDescription.purchaseOrder = purchaseOrder;
        assetDescription.warrantyExpiry = warrantyExpiry;
        assetDescription.expectedEol = expectedEol;
        assetDescription.description = description;
        assetDescription.assetItem = { id: editAssetId };

        AxiosInstance.post(ASSET_DESC_URL, assetDescription)
            .then((response) => {
                showAlert("Asset Description created successfully!", "success");
                getAssetDesc();
            })
            .catch((error) => {
                showAlert("Asset Description creation failed!", "error");
                console.error(error);
            });
    };

    // expose submit to parent via ref
    useImperativeHandle(ref, () => ({
        submit: (event) => handleSubmit(event || { preventDefault: () => {} }),
    }));

    const getAssetDesc = () => {
        AxiosInstance.get(ASSET_DESC_BY_AI_URL + editAssetId)
            .then((response) => {
                var assetDescription = response.data;

                setId(assetDescription?.id);
                setAssetItem(assetDescription.assetItem);
                setMakeModel(assetDescription.makeModel);
                setModel(assetDescription.model);
                setSerial(assetDescription.serial);
                setProcurement(parseISO(assetDescription.procurement));
                setPurchaseOrder(assetDescription.purchaseOrder);
                setWarrantyExpiry(parseISO(assetDescription.warrantyExpiry));
                setExpectedEol(parseISO(assetDescription.expectedEol));
                setDescription(assetDescription.description);
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 404) {
                        console.error("Resource not found (404)");
                        //setAddress("");
                    } else {
                        console.error(
                            "Server responded with error:",
                            error.response.status
                        );
                    }
                } else if (error.request) {
                    console.error("No response from server");
                } else {
                    console.error("Axios error:", error.message);
                }
            });
    };

    return (
        <ThemeProvider theme={theme}>
            <Box
                component="form"
                sx={{ "& .MuiTextField-root": { m: 1 } }}
                noValidate
                autoComplete="off"
            >
                <Grid container spacing={2} columns={16}>
                    <Grid size={8}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Make & Model"
                            label="Make & Model"
                            type="text"
                            fullWidth
                            variant="standard"
                            value={makeModel}
                            onChange={handleMakeModelChange}
                        />
                    </Grid>
                    <Grid size={8}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Model"
                            label="Model"
                            type="text"
                            fullWidth
                            variant="standard"
                            value={model}
                            onChange={handleModelChange}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2} columns={16}>
                    <Grid size={8}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Serial"
                            label="Serial"
                            type="text"
                            variant="standard"
                            fullWidth
                            value={serial}
                            onChange={handleSerialChange}
                        />
                    </Grid>
                    {/* Procurement Date */}
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            value={procurement}
                            onChange={handleProcurementDateChange}
                            label="Procurement"
                            views={["year", "month", "day"]}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid container spacing={2} columns={16}>
                    <Grid size={8}>
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="outlined-multiline-static"
                            name="Purchase Order"
                            label="Purchase Order"
                            type="text"
                            variant="standard"
                            fullWidth
                            value={purchaseOrder}
                            onChange={handlePurchaseOrderChange}
                        />
                    </Grid>
                    {/* Warranty Expiry Date */}
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            value={warrantyExpiry}
                            onChange={handleWarrantyExpDateChange}
                            label="Warranty Exp"
                            views={["year", "month", "day"]}
                        />
                    </LocalizationProvider>
                </Grid>
                {/* Expected EOL Date */}
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        value={expectedEol}
                        onChange={handleExpectedEolChange}
                        label="Expected EOL"
                        views={["year", "month", "day"]}
                    />
                </LocalizationProvider>

                <TextField
                    autoFocus
                    id="outlined-multiline-static"
                    name="description"
                    label="Description"
                    placeholder="Enter Description"
                    fullWidth
                    multiline
                    rows={4}
                    cols={10}
                    value={description}
                    onChange={handleDescriptionChange}
                />
            </Box>
        </ThemeProvider>
    );
}

export default forwardRef(AssetDescription);
